import { useBackground } from '@bm-js/atlascloud-ui'
import { useEditorData, useEditorState } from '../../utils/hooks'
import EditorBreadcrumbs from './EditorBreadcrumbs'
import NavSwitcher from './NavSwitcher'
import { useMemo } from 'react'
import TopLevelContentSwitcher from './TopLevelContentSwitcher'
import FooterSwitcher from './FooterSwitcher'
import { useTr } from '../../utils/useTr'
import { TrKey } from '../../cnst/translations/trKey.cnst'

const EditorCenter = () => {
  const { tr } = useTr()
  const { centerSettings } = useEditorState()
  const { workingConfig, activePage, breadcrumbs } = useEditorData()
  const pageBackground = useBackground(workingConfig.websiteBackground)

  const contentTopPaddingClass = useMemo(() => {
    if (workingConfig.navType !== 'nav2') return ''
    if (activePage?.children?.length || breadcrumbs.length > 1) {
      return '@2xl/top:pt-[100px] pt-[50px]'
    }
    return 'pt-[50px]'
  }, [workingConfig, activePage, breadcrumbs])

  return (
    <div
      className={`relative rounded-md overflow-hidden @container/top customer-font ${pageBackground}`}
      style={{
        marginTop: centerSettings.top,
        marginLeft: centerSettings.left,
        width: centerSettings.width,
        transitionProperty: 'width, height, margin',
        transitionTimingFunction: 'ease',
        transitionDuration: '250ms',
      }}
    >
      <NavSwitcher />
      <div
        className={`overflow-y-scroll ${contentTopPaddingClass}`}
        style={{
          height: centerSettings.height,
        }}
      >
        {activePage ? (
          <>
            <EditorBreadcrumbs />
            {activePage.content.map((content) => (
              <TopLevelContentSwitcher content={content} key={content.uuid} />
            ))}
            <FooterSwitcher />
          </>
        ) : (
          <div className='flex flex-col items-center justify-center h-full'>
            <p className='text-center text-2xl font-bold text-primary-400'>
              {tr(TrKey.editorCenterNoPageSelected)}
            </p>
            <p className='text-center text-sm text-gray-500'>
              {tr(TrKey.editorCenterSelectPage)}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default EditorCenter
